import React, { useState } from "react";
import { CloseIcon } from "~/core/icons";
import { Loader } from "~/core";
import { InjectedIntlProps } from "@ai360/core/intl";
import { pdfUrl } from "@ai360/core";
import { messages } from "../../i18n-messages";

interface IReportViewerProps {
    data?: Record<string, any>;
    closeReportViewer?: () => void;
    currentThemeName?: string;
    formatMessage?: (message: any) => string;
}

export const ReportViewer = (props: IReportViewerProps & InjectedIntlProps) => {
    const LIGHT_THEME = "light";

    const [showLoader, setShowLoader] = useState<boolean>(true);

    const _getThemeFlag = (): number => {
        const { currentThemeName } = props;
        if (currentThemeName.includes(LIGHT_THEME)) {
            return 0;
        }
        return 1;
    };

    const onIframeLoad = (): void => {
        setShowLoader(false);
    };

    const getReportViewerUrl = (): string => {
        const { fileName, loggedInUserGuid, reportUserGuid, isPrint } = props.data;
        return pdfUrl(
            `/RadPdf/Viewer/?loggedInUserGuid=${loggedInUserGuid}&reportUserGuid=${reportUserGuid}&filename=${fileName}&isPrint=${isPrint}&themeOption=${_getThemeFlag()}`
        );
    };

    const url = getReportViewerUrl();
    return (
        <div className="report-viewer">
            {showLoader ? <Loader /> : null}
            <iframe title={"report-viewer"} key={url} src={url} onLoad={onIframeLoad} />
            <div
                title={props.formatMessage(messages.close)}
                className="report-viewer-close"
                onClick={props.closeReportViewer}
            >
                <CloseIcon />
            </div>
        </div>
    );
};

ReportViewer.defaultProps = {
    isPrint: false,
};
